"use client";
import {
  useMenubar
} from "../__chunks/7YV2MWWG.js";
import "../__chunks/62UHHO2X.js";
import "../__chunks/BKQBQI36.js";
import "../__chunks/ITI7HKP4.js";
import "../__chunks/5VQZOHHZ.js";
import "../__chunks/4CMBR7SL.js";
import "../__chunks/C3IKGW5T.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/LVA2YJMS.js";
import "../__chunks/SWN3JYXT.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/LMDWO4NN.js";
import "../__chunks/YV4JVR4I.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/menu/menu-bar.tsx
import { useEffect } from "react";
var TagName = "div";
var useMenuBar = createHook(
  function useMenuBar2(props) {
    useEffect(() => {
      if (process.env.NODE_ENV !== "production") {
        console.warn(
          "MenuBar is deprecated. Use Menubar instead.",
          "See https://ariakit.org/reference/menubar"
        );
      }
    }, []);
    return useMenubar(props);
  }
);
var MenuBar = forwardRef(function MenuBar2(props) {
  const htmlProps = useMenuBar(props);
  return createElement(TagName, htmlProps);
});
export {
  MenuBar,
  useMenuBar
};
